import { Navigate } from "react-router-dom";
import { useContext, useState, useEffect } from "react";
import { AbilityContext } from "Can";
import MDBox from "components/MDBox";

const ProtectedRoute = ({
  isAuthenticated,
  redirectPath = "/auth/login",
  unauthorizedPath = "/unauthorized",
  type,
  children,
}) => {
  const ability = useContext(AbilityContext);
  const [isCheckingPermissions, setIsCheckingPermissions] = useState(true);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setIsCheckingPermissions(false);
    }, 2000);

    return () => clearTimeout(timeoutId);
  }, []);

  // Check if user is authenticated
  if (!isAuthenticated) {
    return <Navigate to={redirectPath} replace />;
  }
  // If no type is specified, assume public route
  if (!type) {
    return children;
  }
  // permissions are loading
  if (isCheckingPermissions && ability.rules.length === 0) {
    return (
      <MDBox
        width="100%"
        height="100%"
        display="flex"
        justifyContent="center"
        alignItems="center"
        sx={{ fontSize: "1.2rem" }}
      >
      </MDBox>
    )
  }
  // permissions
  const canAccess = ability.can("access", type);
  if (!canAccess) {
    return <Navigate to={unauthorizedPath} replace />;
  }

  return children;
};

export default ProtectedRoute;

